// There are currently 2 known district-level exclusions to the reports access roles matrix.  They were found and
// carried over to this new landing page.
// 1.  If assessment.system_configuration importProfile.matchOnId === TRUE, then the users in the district
//     cannot run the Potential Duplicate Profiles report.  As far as I can tell, this is because duplicates are matched
//     for these users at the time of rostering.  In the new landing page, we have decided to remove the report from
//     the operational reports list.
// 2.  There was one hard-coded value in the old reporting-app.conf that turns off access to 2 operational reports for
//     an entire district.  The most expedient way of handling this is to carry over the functionality here.
//     Please note that ADMINISTRATORS in this district will get this access turned back on with the
//     assessment.system_configuration key additional.operational.report.access.  We handle adding access to that
//     report in the roles.js file because this is a role-based access exception.
// There is 1 license that is also a district-level configuration and gives access to the MPG reports

export const matchOnIdAccessExclusions = 'potentialDuplicateProfiles';

export const restrictedOperationalReportAccess = 'studentsWithoutValidTestResults,testEventsByStatus';

export const licenses = {
  PG1: 'screeningAndSkillsChecklistClass,screeningAndSkillsChecklistStudent',
};

export default {
  matchOnIdAccessExclusions,
  restrictedOperationalReportAccess,
  licenses,
};
